import { Moment } from 'moment';
import { TnxLoadStatus } from './tnx-load-status';

export interface TnxLoadListComponentCriteria {
  loadIds?: string[];
  deliveryNumbers?: string[];
  lastEventAfter?: Moment;
  lastEventBefore?: Moment;
  assignmentDeadlineAfter?: Moment;
  assignmentDeadlineBefore?: Moment;
  status?: string;
  originCountryCode?: string;
  destinationCountryCode?: string;
  failedLoads: boolean;
  aboutToExpireLoads: boolean;
  canceledLoads: boolean;
  updatedLoads: boolean;
}

export const defaultCriteria: TnxLoadListComponentCriteria = {
  status: TnxLoadStatus.ALL,
  loadIds: [],
  deliveryNumbers: [],
  failedLoads: false,
  aboutToExpireLoads: false,
  canceledLoads: false,
  updatedLoads: false,
}
